<script>
  import { getContext } from "svelte";
  import Video from "../../components/Video.svelte";
  import CustomIcon from "../../components/CustomIcon.svelte";
  export let title = "";
  export let display = "";
  export let disabled = false;
  export let onInput = null;
  export let name;
  // export let type = "asset";
  // export let acceptRx;
  export let accept = undefined;
  export let folder = undefined;
  export let multiple = false;
  export let previewFile = false;
  export let readonly = false;
  let filename = "";
  export let source;
  export let poster;
  let fileInput;
  async function onRemoveVideo() {
    filename = "";
    source = undefined;
    poster = undefined;
    onFormChange({ detail: { name: "" }, name });
    fileInput.value = "";
  }

  const { onFormChange, getForm } = getContext("form");

  function readLocalVideo(file) {
    let reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        source = reader.result + "#t=0.1";
        const video = document.getElementById("hvideoId");
        const canvas = document.getElementById("canvasId");
        video.addEventListener(
          "loadeddata",
          function () {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext("2d");
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            poster = canvas.toDataURL();
          },
          false
        );
      },
      false
    );
    reader.readAsDataURL(file);
  }
  async function onFileInput(e) {
    onFormChange(e);
    onInput(e);
    // e.preventDefault();
    // console.log(e);
    if (previewFile) {
      filename = fileInput.files[0]?.name;
      if (fileInput.files.length) {
        readLocalVideo(fileInput.files[0]);
      }
    }

    // if (onInput) {
    //   const form = getForm();
    //   const formData = new FormData(form);
    //   const fd = new FormData();
    //   const tempFiles = formData.getAll(name);
    //   if (multiple || folder) {
    //     tempFiles.forEach((f) => {
    //       if (acceptRx && f.type.match(acceptRx)) {
    //         fd.append(name, f);
    //       }
    //     });
    //   } else {
    //     fd.append(name, tempFiles[0]);
    //   }
    //   try {
    //     onInput(fd);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
  }

  function handleDropFiles() {
    e.preventDefault();
    fileInput.files = e.dataTransfer.files;
    onInput(e.dataTransfer.files);
  }
  const webkitdirectory = folder;
  const mozdirectory = folder;
  $: wrapperClass = `h-20 mt-5 border-2 border-custom-orange border-dashed rounded-md overflow-y-auto max-h-[200px] ${
    disabled ? "opacity-50" : "bg-custom-light-orange"
  }`;
  $: inputClass = `relative rounded-md font-medium flex outline-none w-full flex justify-center items-center ${
    disabled ?? "hover:text-yellow-500 cursor-pointer"
  }`;
  // let accept = type == "asset" ? "audio/*,video/*,image/*" : ".csv";
  // let accept = !folder ? (type == "asset" ? "video/*" : ".csv") : null; // support just videos
</script>

<div
  class={wrapperClass}
  on:drop={handleDropFiles}
  on:dragenter={() => console.log("drag")}
  style={poster && source
    ? "visibility: hidden !important;position: absolute !important"
    : "visibility: inherit;"}
>
  <div class="space-y-1 h-full">
    <div class="text-sm flex text-gray-600 h-full">
      <label for={name} class={inputClass}>
        <input
          id={name}
          bind:this={fileInput}
          on:input={onFileInput}
          type="file"
          class="opacity-0 absolute h-full w-full cursor-pointer"
          {accept}
          {name}
          {multiple}
          {disabled}
          {webkitdirectory}
          {mozdirectory}
        />
        {#if !display || !display.length}
          <span class="text-red-500">*</span>
        {/if}
        {#if !display || ((multiple || folder) && !display.length)}
          <span>{title}</span>
        {:else if (multiple || folder) && display.length}
          <ul>
            {#each display as file, i}
              <li class="pl-1">{i + 1}) {file.name}</li>{/each}
          </ul>
        {:else}
          <span class="pl-1">{display.name}</span>
        {/if}
      </label>
    </div>
  </div>
</div>
<div class="w-full flex justify-center">
  {#if source && poster}
    <div class="flex flex-col gap-2 p-4">
      <div class="flex flex-row justify-between items-center">
        <div class="flex text-sm text-gray-800 font-bold">
          {filename}
        </div>
        {#if !readonly}
          <a
            on:click|preventDefault={onRemoveVideo}
            class="rounded border border-transparent"
            href="/"
          >
            <CustomIcon width="20" height="20" name="remove" />
          </a>
        {/if}
      </div>
      <div class="w-[450px] cursor-pointer block">
        <Video {source} {poster} />
      </div>
    </div>
  {/if}
  <div style="display:none;">
    <video id="hvideoId" controls preload="metadata" src={source}>
      <track kind="captions" />
    </video>
    <canvas id="canvasId" />
  </div>
</div>